import { render, staticRenderFns } from "./QueriesList.vue?vue&type=template&id=0c945d9f"
import script from "./QueriesList.vue?vue&type=script&lang=js"
export * from "./QueriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports